<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'acquisti.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="save" class="close" (click)="save()" aria-label="Close">
      <span aria-hidden="true"><i class="fas fa-save"></i></span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">

  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-save"></i> {{'acquisti.salva' | translate}} </span>
  </button>
</div>
